import { createSlice } from "@reduxjs/toolkit";
import axios from "../../services/authService";
import { API_ENDPOINTS } from '../../config/apiConfig';

export const deleteAttributeSlice = createSlice({
    name: "deleteAttribute",
    initialState: {
        loading: false,
        response: {},
        error: null
    },
    reducers: {
        reset: (state) => {
            state.loading = false;
            state.response = {};
            state.error = null;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setResponse: (state, action) => {
            state.response = action.payload;
            state.loading = false;
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        }
    }
});

export const {
    reset,
    setLoading,
    setResponse,
    setError
} = deleteAttributeSlice.actions;

/**
 * Delete an attribute from the database
 * @param {number} attributeDbId - The database ID of the attribute to delete
 * @param {string} scenarioType - The scenario type ('inbound' or 'outbound-*')
 */
export const deleteAttributeAsync = (attributeDbId, scenarioType) => async (dispatch) => {
    dispatch(reset());
    dispatch(setLoading(true));

    try {
        // Determine the parameter name based on scenario type
        const paramName = scenarioType === 'inbound' ? 'inbound_id' : 'outbound_id';

        // Build the URL with query parameter
        const url = `${API_ENDPOINTS.DELETE_ATTRIBUTE}?${paramName}=${attributeDbId}`;

        // Make the DELETE request
        const response = await axios.delete(url);

        dispatch(setResponse({
            message: "Attribute deleted successfully",
            data: response.data
        }));

        return {
            success: true,
            data: response.data
        };

    } catch (err) {
        const errorMessage = err.response?.data?.message || err.message || "Failed to delete attribute";
        console.error("Error deleting attribute:", errorMessage);
        dispatch(setError(errorMessage));
        return {
            success: false,
            error: errorMessage
        };
    }
};

// Selectors
export const selectDeleteAttributeLoading = (state) => state.deleteAttribute.loading;
export const selectDeleteAttributeResponse = (state) => state.deleteAttribute.response;
export const selectDeleteAttributeError = (state) => state.deleteAttribute.error;

export default deleteAttributeSlice.reducer;
